import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ModalState {
  companyInformationModal: boolean;
  contactInformationModal: boolean;
  additionalInformationModal: boolean;
  tourManagementWelcomeModal: boolean;
  transportationChoiceModal: boolean;
  meetingPointAddressModal: boolean;
  meetingPointDifferentAddressModal: boolean;
  meetingPointPickupArea: boolean;
  meetingPointPickupAddress: boolean;
  selectExceptionalDateModal: boolean;
  selectOpeningHoursModal: boolean;
  taxDetailModal: boolean;
  paymentMethodModal: boolean;
  paymentSettingsModal: boolean;
  insuranceProviderModal: boolean,
}

const initialState: ModalState = {
  companyInformationModal: false,
  contactInformationModal: false,
  additionalInformationModal: false,
  tourManagementWelcomeModal: true,
  transportationChoiceModal: false,
  meetingPointAddressModal: false,
  meetingPointPickupArea: false,
  meetingPointPickupAddress: false,
  meetingPointDifferentAddressModal: false,
  selectExceptionalDateModal: false,
  selectOpeningHoursModal: false,
  taxDetailModal: false,
  paymentMethodModal: false,
  paymentSettingsModal: false,
  insuranceProviderModal: false
};

export const user = createSlice({
  name: "user",
  initialState,
  reducers: {
    setCompanyInformationModal: (state, action: PayloadAction<boolean>) => {
      state.companyInformationModal = action.payload;
    },
    setContactInformationModal: (state, action: PayloadAction<boolean>) => {
      state.contactInformationModal = action.payload;
    },
    setAdditionalInformationModal: (state, action: PayloadAction<boolean>) => {
      state.additionalInformationModal = action.payload;
    },
    setTourManagementWelcomeModal: (state, action: PayloadAction<boolean>) => {
      state.tourManagementWelcomeModal = action.payload;
    },
    setTransportationChoiceModal: (state, action: PayloadAction<boolean>) => {
      state.transportationChoiceModal = action.payload;
    },
    setMeetingPointAddressModal: (state, action: PayloadAction<boolean>) => {
      state.meetingPointAddressModal = action.payload;
    },
    setMeetingPickupAreaModal: (state, action: PayloadAction<boolean>) => {
      state.meetingPointPickupArea = action.payload;
    },
    setMeetingPickupAddressModal: (state, action: PayloadAction<boolean>) => {
      state.meetingPointPickupAddress = action.payload;
    },
    setMeetingDifferentAddressModal: (state, action: PayloadAction<boolean>) => {
      state.meetingPointDifferentAddressModal = action.payload;
    },
    setSelectExceptionalDateModal: (state, action: PayloadAction<boolean>) => {
      state.selectExceptionalDateModal = action.payload;
    },
    setSelectOpeningHoursModal: (state, action: PayloadAction<boolean>) => {
      state.selectOpeningHoursModal = action.payload;
    },
    setTaxDetailsModal: (state, action: PayloadAction<boolean>) => {
      state.taxDetailModal = action.payload;
    },
    setPaymentMethodModal: (state, action: PayloadAction<boolean>) => {
      state.paymentMethodModal = action.payload;
    },
    setPaymentSettingModal: (state, action: PayloadAction<boolean>) => {
      state.paymentSettingsModal = action.payload;
    },
    setInsuranceProviderModal: (state, action: PayloadAction<boolean>) => {
      state.insuranceProviderModal = action.payload;
    },
  },
});

export const {
  setCompanyInformationModal,
  setContactInformationModal,
  setAdditionalInformationModal,
  setTourManagementWelcomeModal,
  setTransportationChoiceModal,
  setMeetingPointAddressModal,
  setSelectExceptionalDateModal,
  setSelectOpeningHoursModal,
  setTaxDetailsModal,
  setPaymentMethodModal,
  setPaymentSettingModal,
  setInsuranceProviderModal,
  setMeetingPickupAreaModal,
  setMeetingPickupAddressModal,
  setMeetingDifferentAddressModal
} = user.actions;

export default user.reducer;
